// @flow

import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaOn } from 'frontend_core/dist/styles/media'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { imagePath } from 'frontend_core/dist/helpers/image'

export const SiteFooterExternal = styled.div`
  padding: 32px 0;
  background-color: #373737;
  color: #c9c9c9;
  font-size: 13px;
  ${mediaMax.desktop`
    padding: 20px 0 10px;
  `};
`
export const FooterExternalHead = styled.div`
  position: relative;
  padding-bottom: 10px;
  border-bottom: 1px solid #606060;
  overflow: hidden;
`
export const FooterExternalText = styled.p`
  padding-top: 10px;
  font-size: 12px;
  line-height: 1.4;
  clear: both;
  ${mediaMax.desktop`
    margin-bottom: 15px;
  `};
`
export const FooterExternalLink = styled.a`
  color: #c9c9c9;

  &:hover {
    color: #fff;
  }
`
export const FooterExternalIconLabel = styled.span`
  font-size: 12px;
  float: right;
  padding-top: 3px;
  ${mediaOn.desktop`
    width: 100%;
    display: block;
  `};
`
export const FooterExternalIcon = styled.i`
  margin-left: 4px;
`

export default () => (
  <SiteFooterExternal>
    <div className="container">
      <ul>
        <li className="col-xs-12 col-sm-4 col-md-4">
          <FooterExternalHead>
            <FooterExternalLink href={wwwUrl('/')}>
              <OptimizedImage
                src={imagePath('service/footer/logo_spmkt.png')}
                width="142"
                height="15"
                alt="SPACEMARKET"
              />
              <FooterExternalIconLabel>
                レンタルスペース<FooterExternalIcon />
              </FooterExternalIconLabel>
            </FooterExternalLink>
          </FooterExternalHead>
          <FooterExternalText>
            会議室から球場まで全国のレンタルスペースをかんたん予約。
          </FooterExternalText>
        </li>
        <li className="col-xs-12 col-sm-4 col-md-4">
          <FooterExternalHead>
            <FooterExternalLink
              href="https://business.spacemarket.com/"
              target="_blank"
            >
              <OptimizedImage
                src={imagePath('service/footer/logo_business.png')}
                width="224"
                height="15"
                alt="SPACEMARKET BUSINESS"
              />
              <FooterExternalIconLabel>
                Webサイトへ
                <FooterExternalIcon className="fas fa-external-link-alt" />
              </FooterExternalIconLabel>
            </FooterExternalLink>
          </FooterExternalHead>
          <FooterExternalText>
            社員の予約・利用・支払いを一括管理できる法人向けサービス
          </FooterExternalText>
        </li>
      </ul>
    </div>
  </SiteFooterExternal>
)
